module.exports = __webpack_public_path__ + "static/media/forest-dropdown.ef57febf.jpg";